import { render, staticRenderFns } from "./CriteriaConfigEditor.vue?vue&type=template&id=5d155a2e&scoped=true&"
import script from "./CriteriaConfigEditor.vue?vue&type=script&lang=js&"
export * from "./CriteriaConfigEditor.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaConfigEditor.vue?vue&type=style&index=0&id=5d155a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d155a2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VForm,
  VIcon,
  VTextarea,
})
